export default "__VITE_ASSET__CA4Xq4jL__"